import type {BNApiMethodName} from './bnrks/methods';
import type {BNApiResourceName} from './bnrks/resources';
import type {CoreApiMethodName} from './core/methods';
import type {CoreApiResourceName} from './core/resources';

import {BN_API_RESOURCE_NAMES} from './bnrks/resources';
import {CORE_API_RESOURCE_NAMES} from './core/resources';

export type {
  ApiCountResponse,
  ApiListResponse,
  ApiListResponseExpanded,
  Entity,
  Expand,
  Expanded,
  FlatExpand,
  MaybeExpanded,
} from './types';

export type ApiMethodName = BNApiMethodName | CoreApiMethodName;

export type ApiResourceName = BNApiResourceName | CoreApiResourceName;

export const API_RESOURCE_NAMES = new Set<ApiResourceName>([
  ...Array.from(BN_API_RESOURCE_NAMES),
  ...Array.from(CORE_API_RESOURCE_NAMES),
]);
